import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../Global/EmptyData";
import usePlaceholder from "./usePlaceholder";
import AddPlaceholder from "./AddPlaceholder";
import OrderColumn from "../../Global/OrderColumn";

const Placeholder = () => {
  const {
    isLoading,
    isFetching,
    placeholderList,
    showEditModal,
    placeholderState,
    paginationOptions,
    handleEditColumnsClick,
    updatePlaceholderFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = usePlaceholder();

  return (
    <div>
      <HeadingGroup
        title={"Dynamic Placeholder"}
        className={`pro-mb-4`}
        buttonTitle={placeholderList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={placeholderState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: placeholderState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {placeholderList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={placeholderList?.data?.result || []}
            uniqueID={"id"}
            fields={placeholderList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={placeholderState?.clearSelection}
            loading={isFetching}
            perpage={placeholderState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={placeholderList?.delete_permission}
            editable={placeholderList?.edit_permission}
            showCheckBox={
              placeholderList?.delete_permission ||
              placeholderList?.edit_permission
            }
          />
        )}

        {placeholderList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={placeholderState?.currentPage}
            totalPageCount={Math.ceil(
              placeholderList?.data?.total_count / placeholderState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === placeholderState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={placeholderState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected placeholder ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={placeholderList?.fields || []}
              moduleId={placeholderList?.module_id}
              updateData={updatePlaceholderFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={placeholderState?.showCreateModal}
          handleClose={handleCreateClick}
          title={placeholderState?.isEdit ? "Update Dynamic Placeholder" : "Add Dynamic Placeholder"}
          backdrop={"static"}
        >
          <AddPlaceholder
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
          />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default Placeholder;
